import getLayout from './get-modal-layout';
import Modal from './modal';

// import "jquery"
import "../../../vendor/jquery.paver.min"


class ModalPanorama extends Modal {
  constructor() {
    super();
    this.toggle = this.page.querySelector(`.js-modal-panorama`);
  }

  init(options) {
    this.onShow = options.onShow;
    this.togglers = document.querySelector(options.wrapperClass).querySelectorAll(options.itemClass);

    super.createModal();
    this.createPanoramaWrap();

    this.container = options.container();

    this.bindHandlers();
  }

  toggleModal = (isModalShown) => {
    super._toggleModal(isModalShown);
    const container = $(this.container);
    if (isModalShown) {
      container.paver({
        mouseSmoothingFunction: 'gaussian',
        tiltSmoothingFunction: 'gaussian',
        startPosition: 0.1,
        gyroscopeThrottle: 1000 / 30,
      });
    }
  };

  createPanoramaWrap() {
    super.addLayout(getLayout(`modal-panorama`));
    this.name = document.querySelector('.wrapper').getAttribute('data-panorama');
  };

  createPanorama(link) {
    this.container.innerHTML = `<img src="${link}" alt="Вид из окна">`;
  };

  bindHandlers() {
    let html = document.querySelector('html');
    let body = document.querySelector('body');

    this.togglers.forEach(toggle => {

      if (toggle) {
        toggle.addEventListener(`click`, (ev) => {
          ev.preventDefault();
          let link = this.onShow(ev, this);
          this.container.innerHTML = `<img src="${link}" alt="Вид из окна">`;
          this.toggleModal(true);

          html.classList.add('modal--safari');
          body.classList.add('modal--safari');
        });
      }
    });

    if (this.close) {
      this.close.addEventListener(`click`, (ev) => {
        ev.preventDefault();
        this.toggleModal(false);
        $(this.container).paver('destroy');

        html.classList.remove('modal--safari');
        body.classList.remove('modal--safari');
      });
    }
  }
}

const modalPanorama = new ModalPanorama();

export default modalPanorama;
